import marcaBlancaServices from 'legacyfrontend/api/services/marcaBlancaServices';
import { SET_BANNERS, SET_BANNERS_ERROR } from './action-types';
import { safeLocalStorage, useLocalStorage } from 'legacyfrontend/helpers/ssr-helper';

export const getBanners =
  ({ id = null, esDefault = true, defaultOnly, showHomeOnly }) =>
  async (dispatch, getState) => {
    const state = getState();
    const seccionId =
      id === null && state.applicationState?.templateData?.mainMenu?.length > 0
        ? state.applicationState.templateData.mainMenu[0].id
        : id;
    const empresaId = state.applicationState.applicationId;

    try {
      const response = await marcaBlancaServices.getBanners({
        empresaId,
        seccionId,
        esDefault,
        defaultOnly,
        showHome: showHomeOnly,
      });

      let bannersData = [];
      if (response?.data) {
        if (response.data.object && Array.isArray(response.data.object)) {
          bannersData = response.data.object;
        } else if (Array.isArray(response.data)) {
          bannersData = response.data;
        }
      } else if (Array.isArray(response)) {
        bannersData = response;
      }

      if (bannersData && bannersData.length > 0) {
        safeLocalStorage.setItem('paisId', bannersData[0].categoria?.paisId);
        safeLocalStorage.setItem('banners', JSON.stringify(bannersData));
      }
      return dispatch({
        type: SET_BANNERS,
        payload: bannersData,
      });
    } catch (error) {
      console.error('Banners error', error);
      return dispatch({ type: SET_BANNERS_ERROR });
    }
  };
